import React from "react";
import {
  AiOutlineLogin,
} from "react-icons/ai";
import {
  RiLockPasswordLine,
} from "react-icons/ri";
import {
  HiOutlineReceiptRefund,
  HiOutlineShoppingBag,
} from "react-icons/hi";
import {
  FaMoneyBillWave,
} from "react-icons/fa";
import {
  MdOutlineAddShoppingCart,
  MdOutlineAdminPanelSettings,
  MdOutlineTrackChanges,
} from "react-icons/md";
import {
  TbAddressBook,
} from "react-icons/tb";
import {
  RxPerson,
} from "react-icons/rx";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const ProfileSidebar = ({ setActive, active }) => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const logoutHandler = () => {
    axios
      .get(`${server}/user/logout`, { withCredentials: true })
      .then((res) => {
        toast.success(res.data.message);
        window.location.reload(true);
        navigate("/login");
      })
      .catch((error) => {
        console.log(error.response.data.message);
        toast.error("Logout failed. Please try again.");
      });
  };

  const menuItems = [
    { id: 1, name: "Profile", icon: <RxPerson size={22} /> },
    { id: 2, name: "Orders", icon: <HiOutlineShoppingBag size={22} /> },
    { id: 3, name: "Refunds", icon: <HiOutlineReceiptRefund size={22} /> },
    { id: 5, name: "Track Order", icon: <MdOutlineTrackChanges size={22} /> },
    { id: 6, name: "Change Password", icon: <RiLockPasswordLine size={22} /> },
    { id: 7, name: "Address", icon: <TbAddressBook size={22} /> },
    { id: 8, name: "Saved Carts", icon: <MdOutlineAddShoppingCart size={22} /> },
    { id: 9, name: "Transactions", icon: <FaMoneyBillWave size={22} /> },
  ];

  if (user && user.role === "Admin") {
    menuItems.push({
      id: 10,
      name: "Admin Dashboard",
      icon: <MdOutlineAdminPanelSettings size={22} />,
      link: "/admin/dashboard",
    });
  }

  return (
    <div className="w-full md:w-64 bg-gradient-to-b from-gray-50 to-gray-100 shadow-sm rounded-lg p-4 -mt-10">
      {/* User Info: Hidden on Mobile */}
      <div className="hidden md:flex flex-col items-center mb-6">
        <img
          src={user?.avatar?.url || "/default-avatar.png"}
          alt="User Avatar"
          className="w-16 h-16 rounded-full object-cover mb-3 border-2 border-green-500"
        />
        <h3 className="text-lg font-semibold text-center text-gray-800">{user?.name}</h3>
        <p className="text-sm text-gray-600 text-center">{user?.email}</p>
      </div>

      {/* Menu Items */}
      <nav className="flex flex-col space-y-2">
        {menuItems.map((item) => (
          item.link ? (
            <Link
              to={item.link}
              key={item.id}
              onClick={() => setActive(item.id)}
              className={`flex flex-col items-center md:flex-row md:items-center p-3 rounded-lg hover:bg-green-50 transition-colors ${
                active === item.id ? "bg-green-100 shadow-inner" : ""
              }`}
              aria-label={item.name}
            >
              {React.cloneElement(item.icon, {
                color: active === item.id ? "#16a34a" : "#6b7280", // Tailwind green-600 or gray-500
              })}
              <span
                className={`mt-1 md:mt-0 md:ml-3 text-xs md:text-sm font-medium text-center ${
                  active === item.id ? "text-green-600" : "text-gray-700"
                }`}
              >
                {item.name}
              </span>
            </Link>
          ) : (
            <div
              key={item.id}
              onClick={() => setActive(item.id)}
              className={`flex flex-col items-center md:flex-row md:items-center p-3 rounded-lg hover:bg-green-50 transition-colors cursor-pointer ${
                active === item.id ? "bg-green-100 shadow-inner" : ""
              }`}
              aria-label={item.name}
            >
              {React.cloneElement(item.icon, {
                color: active === item.id ? "#16a34a" : "#6b7280",
              })}
              <span
                className={`mt-1 md:mt-0 md:ml-3 text-xs md:text-sm font-medium text-center ${
                  active === item.id ? "text-green-600" : "text-gray-700"
                }`}
              >
                {item.name}
              </span>
            </div>
          )
        ))}
      </nav>

      {/* Logout Button */}
      <div
        onClick={logoutHandler}
        className={`flex flex-col items-center md:flex-row md:items-center p-3 rounded-lg hover:bg-green-50 transition-colors cursor-pointer mt-auto ${
          active === 11 ? "bg-green-100 shadow-inner" : ""
        }`}
        aria-label="Log out"
      >
        <AiOutlineLogin
          size={22}
          color={active === 11 ? "#16a34a" : "#6b7280"}
        />
        <span
          className={`mt-1 md:mt-0 md:ml-3 text-xs md:text-sm font-medium text-center ${
            active === 11 ? "text-green-600" : "text-gray-700"
          }`}
        >
          Log out
        </span>
      </div>
    </div>
  );
};

export default ProfileSidebar;
